import {
  FETCH_DELETE_EVENTS_REQUEST,
  FETCH_DELETE_EVENTS_SUCCESS,
  FETCH_DELETE_EVENTS_FAILURE,
} from "../../actions/events/delete-event-action";

const initialState = {
  removed: null,
  isLoading: false,
  error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteEventReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DELETE_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DELETE_EVENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        removed: action.payload || true,
      };
    case FETCH_DELETE_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default DeleteEventReducer;
